{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Izbriši Shopify integraciju",
        "MESSAGE": "Jeste li sigurni da želite izbrisati Shopify integraciju?"
      },
      "STORE_URL": {
        "TITLE": "Poveži Shopify trgovinu",
        "LABEL": "URL trgovine",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Unesite myshopify.com URL svoje Shopify trgovine",
        "CANCEL": "Odustani",
        "SUBMIT": "Poveži trgovinu"
      },
      "ERROR": "Došlo je do greške pri povezivanju sa Shopifyjem. Pokušajte ponovno ili se obratite podršci ako se problem nastavi."
    },
    "HEADER": "Integracije",
    "DESCRIPTION": "Kontaktni centar se integrira s brojnim alatima i uslugama kako bi poboljšao učinkovitost vašeg tima. Pregledajte popis u nastavku i konfigurirajte svoje omiljene aplikacije.",
    "LEARN_MORE": "Saznajte više o integracijama",
    "LOADING": "Dohvaćanje integracija",
    "CAPTAIN": {
      "DISABLED": "Captain nije omogućen na vašem računu.",
      "CLICK_HERE_TO_CONFIGURE": "Kliknite ovdje za konfiguraciju",
      "LOADING_CONSOLE": "Učitavanje Captain konzole...",
      "FAILED_TO_LOAD_CONSOLE": "Učitavanje Captain konzole nije uspjelo. Osvježite stranicu i pokušajte ponovno."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Pretplaćeni događaji",
      "LEARN_MORE": "Saznajte više o webhookovima",
      "FORM": {
        "CANCEL": "Odustani",
        "DESC": "Webhook događaji pružaju vam informacije u stvarnom vremenu o tome što se događa u vašem računu. Unesite valjani URL za konfiguraciju povratnog poziva.",
        "SUBSCRIPTIONS": {
          "LABEL": "Događaji",
          "EVENTS": {
            "INBOX_CREATED": "Sandučić kreiran",
            "CONVERSATION_CREATED": "Razgovor kreiran",
            "CONVERSATION_STATUS_CHANGED": "Status razgovora promijenjen",
            "CONVERSATION_UPDATED": "Razgovor ažuriran",
            "MESSAGE_CREATED": "Poruka kreirana",
            "MESSAGE_UPDATED": "Poruka ažurirana",
            "WEBWIDGET_TRIGGERED": "Korisnik je otvorio widget za chat uživo",
            "CONTACT_CREATED": "Kontakt kreiran",
            "CONTACT_UPDATED": "Kontakt ažuriran",
            "JARABOT_EVENT": "Interni događaji"
          }
        },
        "END_POINT": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Primjer: {webhookExampleURL}",
          "ERROR": "Unesite valjani URL"
        },
        "EDIT_SUBMIT": "Ažuriraj webhook",
        "ADD_SUBMIT": "Kreiraj webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Konfiguriraj",
      "HEADER": "Webhook postavke",
      "HEADER_BTN_TXT": "Dodaj novi webhook",
      "LOADING": "Dohvaćanje povezanih webhookova",
      "SEARCH_404": "Nema stavki koje odgovaraju ovom upitu",
      "SIDEBAR_TXT": "<p><b>Webhookovi</b> </p> <p>Webhookovi su HTTP povratni pozivi koji se mogu definirati za svaki račun. Pokreću ih događaji kao što je kreiranje poruke. Za ovaj račun možete kreirati više webhookova. <br /><br /> Za kreiranje <b>webhooka</b> kliknite gumb <b>Dodaj novi webhook</b>. Postojeći webhook možete ukloniti klikom na gumb Izbriši.</p>",
      "LIST": {
        "404": "Za ovaj račun nema konfiguriranih webhookova.",
        "TITLE": "Upravljanje webhookovima",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhook endpoint",
          "ACTIONS": "Radnje"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Uredi",
        "TITLE": "Uredi webhook",
        "API": {
          "SUCCESS_MESSAGE": "Konfiguracija webhooka uspješno ažurirana",
          "ERROR_MESSAGE": "Povezivanje s chat poslužiteljem nije uspjelo. Pokušajte kasnije."
        }
      },
      "ADD": {
        "CANCEL": "Odustani",
        "TITLE": "Dodaj novi webhook",
        "API": {
          "SUCCESS_MESSAGE": "Konfiguracija webhooka uspješno dodana",
          "ERROR_MESSAGE": "Povezivanje s chat poslužiteljem nije uspjelo. Pokušajte kasnije."
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Izbriši",
        "API": {
          "SUCCESS_MESSAGE": "Webhook uspješno izbrisan",
          "ERROR_MESSAGE": "Povezivanje s chat poslužiteljem nije uspjelo. Pokušajte kasnije."
        },
        "CONFIRM": {
          "TITLE": "Potvrdi brisanje",
          "MESSAGE": "Jeste li sigurni da želite izbrisati webhook? ({webhookURL})",
          "YES": "Da, izbriši",
          "NO": "Ne, zadrži"
        }
      },
      "DISABLED_BADGE": "Onemogućeno",
      "DISABLED_REASON": "Automatski onemogućeno nakon {count} uzastopnih neuspjeha. Zadnja greška: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Omogući",
        "API": {
          "SUCCESS_MESSAGE": "Webhook uspješno omogućen",
          "ERROR_MESSAGE": "Omogućavanje webhooka nije uspjelo. Pokušajte kasnije."
        }
      }
    },
    "SLACK": {
      "DELETE": "Izbriši",
      "DELETE_CONFIRMATION": {
        "TITLE": "Izbriši integraciju",
        "MESSAGE": "Jeste li sigurni da želite izbrisati integraciju? Time ćete izgubiti pristup razgovorima u svom Slack radnom prostoru."
      },
      "HELP_TEXT": {
        "TITLE": "Using Slack Integration",
        "BODY": "Uz ovu integraciju svi vaši dolazni razgovori sinkronizirat će se s kanalom ***{selectedChannelName}*** u vašem Slack radnom prostoru. Sve razgovore s klijentima možete voditi izravno u kanalu i nikad nećete propustiti poruku.\n\nGlavne značajke integracije:\n\n**Odgovarajte na razgovore iz Slacka:** Za odgovor na razgovor u Slack kanalu ***{selectedChannelName}*** napišite poruku i pošaljite je kao nit. Time se odgovor šalje klijentu putem kontaktnog centra. Tako je jednostavno!\n\n **Kreirajte privatne bilješke:** Ako umjesto odgovora želite kreirati privatnu bilješku, započnite poruku s ***`note:`***. Tako poruka ostaje privatna i klijent je ne vidi.\n\n**Povežite profil agenta:** Ako osoba koja je odgovorila u Slacku ima profil agenta u kontaktnom centru s istom e-mail adresom, odgovori se automatski povezuju s tim profilom agenta. Tako lako pratite tko je što rekao i kada. Ako osoba koja odgovara nema povezani profil agenta, klijent vidi odgovore od profila bota.",
        "SELECTED": "odabrani"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Odaberi kanal",
        "UPDATE": "Ažuriraj",
        "BUTTON_TEXT": "Poveži kanal",
        "DESCRIPTION": "Vaš Slack radni prostor sada je povezan s kontaktnim centrom. Integracija je, međutim, trenutno neaktivna. Za aktivaciju integracije i povezivanje kanala kliknite gumb ispod.\n\n**Napomena:** Ako povezujete privatni kanal, prije ovog koraka dodajte našu aplikaciju u Slack kanal.",
        "ATTENTION_REQUIRED": "Potrebna je pažnja",
        "EXPIRED": "Vaša Slack integracija je istekla. Za nastavak primanja poruka u Slacku izbrišite integraciju i ponovno povežite svoj radni prostor."
      },
      "UPDATE_ERROR": "Došlo je do greške pri ažuriranju integracije, pokušajte ponovno",
      "UPDATE_SUCCESS": "Kanal je uspješno povezan",
      "FAILED_TO_FETCH_CHANNELS": "Došlo je do greške pri dohvaćanju kanala iz Slacka, pokušajte ponovno"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI pomoć",
      "WITH_AI": " {option} s AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Prijedlog odgovora",
        "SUMMARIZE": "Sažmi",
        "REPHRASE": "Poboljšaj pisanje",
        "FIX_SPELLING_GRAMMAR": "Ispravi pravopis i gramatiku",
        "SHORTEN": "Skrati",
        "EXPAND": "Proširi",
        "MAKE_FRIENDLY": "Promijeni ton poruke u prijateljski",
        "MAKE_FORMAL": "Koristi formalni ton",
        "SIMPLIFY": "Pojednostavi",
        "TRANSLATE": "Prevedi",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Prevedi na većinski jezik"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Sadržaj skice",
        "GENERATED_TITLE": "Generirani sadržaj",
        "AI_WRITING": "AI piše",
        "BUTTONS": {
          "APPLY": "Koristi ovaj prijedlog",
          "CANCEL": "Odustani"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integriraj s OpenAI",
        "DESC": "Donesite napredne AI značajke u svoj dashboard uz OpenAI GPT modele. Za početak unesite API ključ iz svog OpenAI računa.",
        "KEY_PLACEHOLDER": "Unesite svoj OpenAI API ključ",
        "BUTTONS": {
          "NEED_HELP": "Trebate pomoć?",
          "DISMISS": "Odustani",
          "FINISH": "Završi postavljanje"
        },
        "DISMISS_MESSAGE": "OpenAI integraciju možete postaviti kasnije, kad god želite.",
        "SUCCESS_MESSAGE": "OpenAI integracija uspješno postavljena"
      },
      "TITLE": "Poboljšaj s AI",
      "SUMMARY_TITLE": "Sažetak s AI",
      "REPLY_TITLE": "Prijedlog odgovora s AI",
      "SUBTITLE": "Poboljšani odgovor će se generirati uz pomoć AI, bazirano na trenutnom odgovoru.",
      "TONE": {
        "TITLE": "Ton",
        "OPTIONS": {
          "PROFESSIONAL": "Profesionalno",
          "FRIENDLY": "Prijateljski"
        }
      },
      "BUTTONS": {
        "GENERATE": "Generiraj",
        "GENERATING": "Generiranje...",
        "CANCEL": "Odustani"
      },
      "GENERATE_ERROR": "Došlo je do greške tijekom procesiranja sadržaja, molim pokušajte ponovno"
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Integracija uspješno izbrisana"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Poveži"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Aplikacije nadzorne ploče",
      "HEADER_BTN_TXT": "Dodaj novu aplikaciju nadzorne ploče",
      "SIDEBAR_TXT": "<p><b>Aplikacije nadzorne ploče</b></p><p>Aplikacije nadzorne ploče omogućuju organizacijama da ugrade aplikaciju u nadzornu ploču i agentima korisničke podrške pruže kontekst. Ova značajka omogućuje vam da samostalno izradite aplikaciju i ugradite je u nadzornu ploču kako bi prikazivala podatke o korisniku, njegove narudžbe ili povijest plaćanja.</p><p>Kada ugradite svoju aplikaciju u nadzornu ploču, aplikacija dobiva kontekst razgovora i kontakta kao window događaj. Na svojoj stranici implementirajte listener za događaj message kako biste primili kontekst.</p><p>Za dodavanje nove aplikacije nadzorne ploče kliknite gumb 'Dodaj novu aplikaciju nadzorne ploče'.</p>",
      "DESCRIPTION": "Aplikacije nadzorne ploče omogućuju organizacijama da ugrade aplikaciju u nadzornu ploču i agentima korisničke podrške pruže kontekst. Ova značajka omogućuje vam da samostalno izradite aplikaciju i ugradite je kako bi prikazivala podatke o korisniku, njegove narudžbe ili povijest plaćanja.",
      "LEARN_MORE": "Saznajte više o aplikacijama nadzorne ploče",
      "LIST": {
        "404": "Na ovom računu još nema konfiguriranih aplikacija nadzorne ploče",
        "LOADING": "Dohvaćanje aplikacija nadzorne ploče...",
        "TABLE_HEADER": {
          "NAME": "Ime",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Uredi aplikaciju",
        "DELETE_TOOLTIP": "Izbriši aplikaciju"
      },
      "FORM": {
        "TITLE_LABEL": "Ime",
        "TITLE_PLACEHOLDER": "Unesite naziv aplikacije nadzorne ploče",
        "TITLE_ERROR": "Naziv aplikacije nadzorne ploče je obavezan",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Unesite URL endpointa na kojem je aplikacija hostana",
        "URL_ERROR": "Potreban je valjani URL"
      },
      "CREATE": {
        "HEADER": "Dodaj novu aplikaciju nadzorne ploče",
        "FORM_SUBMIT": "Pošalji",
        "FORM_CANCEL": "Odustani",
        "API_SUCCESS": "Aplikacija nadzorne ploče uspješno konfigurirana",
        "API_ERROR": "Kreiranje aplikacije nije uspjelo. Pokušajte kasnije"
      },
      "UPDATE": {
        "HEADER": "Uredi aplikaciju nadzorne ploče",
        "FORM_SUBMIT": "Ažuriraj",
        "FORM_CANCEL": "Odustani",
        "API_SUCCESS": "Aplikacija nadzorne ploče uspješno ažurirana",
        "API_ERROR": "Ažuriranje aplikacije nije uspjelo. Pokušajte kasnije"
      },
      "DELETE": {
        "CONFIRM_YES": "Da, izbriši",
        "CONFIRM_NO": "Ne, zadrži",
        "TITLE": "Potvrdi brisanje",
        "MESSAGE": "Jeste li sigurni da želite izbrisati aplikaciju {appName}?",
        "API_SUCCESS": "Aplikacija nadzorne ploče uspješno izbrisana",
        "API_ERROR": "Brisanje aplikacije nije uspjelo. Pokušajte kasnije"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Kreiraj/poveži Linear zadatak",
      "LOADING": "Dohvaćanje Linear zadataka...",
      "LOADING_ERROR": "Došlo je do greške pri dohvaćanju Linear zadataka, pokušajte ponovno",
      "CREATE": "Izradi",
      "LINK": {
        "SEARCH": "Pretraži zadatke",
        "SELECT": "Odaberi zadatak",
        "TITLE": "Povezica",
        "EMPTY_LIST": "Nema pronađenih Linear zadataka",
        "LOADING": "Učitavanje",
        "ERROR": "Došlo je do greške pri dohvaćanju Linear zadataka, pokušajte ponovno",
        "LINK_SUCCESS": "Zadatak uspješno povezan",
        "LINK_ERROR": "Došlo je do greške pri povezivanju zadatka, pokušajte ponovno",
        "LINK_TITLE": "Razgovor (#{conversationId}) s {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Kreiraj/poveži Linear zadatak",
        "DESCRIPTION": "Kreirajte Linear zadatke iz razgovora ili povežite postojeće radi jednostavnog praćenja.",
        "FORM": {
          "TITLE": {
            "LABEL": "Naslov",
            "PLACEHOLDER": "Unesite naslov",
            "REQUIRED_ERROR": "Naslov je obavezan"
          },
          "DESCRIPTION": {
            "LABEL": "Opis",
            "PLACEHOLDER": "Unesite opis"
          },
          "TEAM": {
            "LABEL": "Tim",
            "PLACEHOLDER": "Odaberi tim",
            "SEARCH": "Pretraži tim",
            "REQUIRED_ERROR": "Tim je obavezan"
          },
          "ASSIGNEE": {
            "LABEL": "Dodijeljena osoba",
            "PLACEHOLDER": "Odaberi izvršitelja",
            "SEARCH": "Pretraži izvršitelja"
          },
          "PRIORITY": {
            "LABEL": "Prioritet",
            "PLACEHOLDER": "Odaberi prioritet",
            "SEARCH": "Pretraži prioritet"
          },
          "LABEL": {
            "LABEL": "Oznaka",
            "PLACEHOLDER": "Odaberi oznaku",
            "SEARCH": "Pretraži oznaku"
          },
          "STATUS": {
            "LABEL": "Status",
            "PLACEHOLDER": "Odaberi status",
            "SEARCH": "Pretraži status"
          },
          "PROJECT": {
            "LABEL": "Projekt",
            "PLACEHOLDER": "Odaberi projekt",
            "SEARCH": "Pretraži projekt"
          }
        },
        "CREATE": "Izradi",
        "CANCEL": "Odustani",
        "CREATE_SUCCESS": "Zadatak uspješno kreiran",
        "CREATE_ERROR": "Došlo je do greške pri kreiranju zadatka, pokušajte ponovno",
        "LOADING_TEAM_ERROR": "Došlo je do greške pri dohvaćanju timova, pokušajte ponovno",
        "LOADING_TEAM_ENTITIES_ERROR": "Došlo je do greške pri dohvaćanju entiteta tima, pokušajte ponovno"
      },
      "ISSUE": {
        "STATUS": "Status",
        "PRIORITY": "Prioritet",
        "ASSIGNEE": "Dodijeljena osoba",
        "LABELS": "Oznake",
        "CREATED_AT": "Kreirano {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Ukloni poveznicu",
        "SUCCESS": "Veza sa zadatkom uspješno uklonjena",
        "ERROR": "Došlo je do greške pri uklanjanju veze sa zadatkom, pokušajte ponovno"
      },
      "DELETE": {
        "TITLE": "Jeste li sigurni da želite izbrisati integraciju?",
        "MESSAGE": "Jeste li sigurni da želite izbrisati integraciju?",
        "CONFIRM": "Da, izbriši",
        "CANCEL": "Odustani"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Saznajte više",
    "COPILOT": {
      "SEND_MESSAGE": "Pošalji poruku...",
      "EMPTY_MESSAGE": "Došlo je do greške pri generiranju odgovora. Pokušajte ponovno.",
      "LOADER": "Captain razmišlja",
      "YOU": "Vi",
      "USE": "Koristi ovo",
      "RESET": "Poništi",
      "SELECT_ASSISTANT": "Odaberi asistenta"
    },
    "PAYWALL": {
      "TITLE": "Nadogradite za korištenje Captain AI",
      "AVAILABLE_ON": "Captain nije dostupan u besplatnom planu.",
      "UPGRADE_PROMPT": "Nadogradite plan za pristup asistentima, copilotu i još mnogo toga.",
      "UPGRADE_NOW": "Nadogradi sada",
      "CANCEL_ANYTIME": "Plan možete promijeniti ili otkazati u bilo kojem trenutku"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Značajka Captain AI dostupna je samo u plaćenom planu.",
      "UPGRADE_PROMPT": "Nadogradite plan za pristup asistentima, copilotu i još mnogo toga.",
      "ASK_ADMIN": "Za nadogradnju se obratite svom administratoru."
    },
    "BANNER": {
      "RESPONSES": "Iskoristili ste više od 80 % ograničenja odgovora. Za nastavak korištenja Captain AI nadogradite plan.",
      "DOCUMENTS": "Dosegnuto je ograničenje dokumenata. Nadogradite plan za nastavak korištenja Captain AI."
    },
    "FORM": {
      "CANCEL": "Odustani",
      "CREATE": "Izradi",
      "EDIT": "Ažuriraj"
    },
    "ASSISTANTS": {
      "HEADER": "Asistenti",
      "ADD_NEW": "Kreiraj novog asistenta",
      "DELETE": {
        "TITLE": "Jeste li sigurni da želite izbrisati asistenta?",
        "DESCRIPTION": "Ova radnja je trajna. Brisanjem asistenta uklonit ćete ga iz svih povezanih sandučića i trajno izbrisati sve generirano znanje.",
        "CONFIRM": "Da, izbriši",
        "SUCCESS_MESSAGE": "Asistent je uspješno izbrisan",
        "ERROR_MESSAGE": "Došlo je do greške pri brisanju asistenta, pokušajte ponovno."
      },
      "FORM_DESCRIPTION": "Ispunite podatke u nastavku: dodijelite asistentu ime, opišite njegovu svrhu i navedite proizvod koji će podržavati.",
      "CREATE": {
        "TITLE": "Kreiraj asistenta",
        "SUCCESS_MESSAGE": "Asistent je uspješno kreiran",
        "ERROR_MESSAGE": "Došlo je do greške pri kreiranju asistenta, pokušajte ponovno."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Ime asistenta",
          "PLACEHOLDER": "Unesite ime asistenta",
          "ERROR": "Unesite ime asistenta"
        },
        "DESCRIPTION": {
          "LABEL": "Opis asistenta",
          "PLACEHOLDER": "Opišite kako i gdje će se ovaj asistent koristiti",
          "ERROR": "Opis je obavezan"
        },
        "PRODUCT_NAME": {
          "LABEL": "Naziv proizvoda",
          "PLACEHOLDER": "Unesite naziv proizvoda za koji je ovaj asistent namijenjen",
          "ERROR": "Naziv proizvoda je obavezan"
        },
        "FEATURES": {
          "TITLE": "Značajke",
          "ALLOW_CONVERSATION_FAQS": "Generiraj česta pitanja iz riješenih razgovora",
          "ALLOW_MEMORIES": "Spremaj ključne pojedinosti iz interakcija s klijentima kao sjećanja."
        }
      },
      "EDIT": {
        "TITLE": "Ažuriraj asistenta",
        "SUCCESS_MESSAGE": "Asistent je uspješno ažuriran",
        "ERROR_MESSAGE": "Došlo je do greške pri ažuriranju asistenta, pokušajte ponovno."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Uredi asistenta",
        "DELETE_ASSISTANT": "Izbriši asistenta",
        "VIEW_CONNECTED_INBOXES": "Prikaži povezane sandučiće"
      },
      "EMPTY_STATE": {
        "TITLE": "Nema dostupnih asistenata",
        "SUBTITLE": "Kreirajte asistenta koji će vašim korisnicima davati brze i točne odgovore. Može učiti iz vaših članaka pomoći i prošlih razgovora.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain asistent",
          "NOTE": "Captain asistent komunicira izravno s klijentima, uči iz vaše dokumentacije pomoći i prošlih razgovora te daje trenutne i točne odgovore. Obrađuje početne upite i nudi brza rješenja prije nego što po potrebi preda razgovor agentu."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Dokumenti",
      "ADD_NEW": "Kreiraj novi dokument",
      "RELATED_RESPONSES": {
        "TITLE": "Povezana česta pitanja",
        "DESCRIPTION": "Ova česta pitanja generirana su izravno iz dokumenta."
      },
      "FORM_DESCRIPTION": "Unesite URL dokumenta kako biste ga dodali kao izvor znanja i odaberite asistenta s kojim ga želite povezati.",
      "CREATE": {
        "TITLE": "Dodaj dokument",
        "SUCCESS_MESSAGE": "Dokument je uspješno kreiran",
        "ERROR_MESSAGE": "Došlo je do greške pri kreiranju dokumenta, pokušajte ponovno."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Unesite URL dokumenta",
          "ERROR": "Unesite valjani URL dokumenta"
        },
        "ASSISTANT": {
          "LABEL": "Asistent",
          "PLACEHOLDER": "Odaberite asistenta",
          "ERROR": "Polje asistenta je obavezno"
        }
      },
      "DELETE": {
        "TITLE": "Jeste li sigurni da želite izbrisati dokument?",
        "DESCRIPTION": "Ova radnja je trajna. Brisanjem dokumenta trajno ćete izbrisati sve generirano znanje.",
        "CONFIRM": "Da, izbriši",
        "SUCCESS_MESSAGE": "Dokument je uspješno izbrisan",
        "ERROR_MESSAGE": "Došlo je do greške pri brisanju dokumenta, pokušajte ponovno."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "Prikaži povezane odgovore",
        "DELETE_DOCUMENT": "Izbriši dokument"
      },
      "EMPTY_STATE": {
        "TITLE": "Nema dostupnih dokumenata",
        "SUBTITLE": "Asistent koristi dokumente za generiranje čestih pitanja. Možete uvesti dokumente kako biste asistentu pružili kontekst.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain dokument",
          "NOTE": "Dokument u Captainu služi kao izvor znanja za asistenta. Kada povežete svoj centar za pomoć ili vodiče, Captain može analizirati sadržaj i davati točne odgovore na upite klijenata."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "Česta pitanja",
      "ADD_NEW": "Kreiraj novo često pitanje",
      "DOCUMENTABLE": {
        "CONVERSATION": "Razgovor #{id}"
      },
      "SELECTED": "Odabrano: {count}",
      "BULK_APPROVE_BUTTON": "Odobri",
      "BULK_DELETE_BUTTON": "Izbriši",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "Česta pitanja uspješno odobrena",
        "ERROR_MESSAGE": "Došlo je do greške pri odobravanju čestih pitanja, pokušajte ponovno."
      },
      "BULK_DELETE": {
        "TITLE": "Izbrisati česta pitanja?",
        "DESCRIPTION": "Jeste li sigurni da želite izbrisati odabrana česta pitanja? Ova radnja se ne može poništiti.",
        "CONFIRM": "Da, izbriši sve",
        "SUCCESS_MESSAGE": "Česta pitanja uspješno izbrisana",
        "ERROR_MESSAGE": "Došlo je do greške pri brisanju čestih pitanja, pokušajte ponovno."
      },
      "DELETE": {
        "TITLE": "Jeste li sigurni da želite izbrisati često pitanje?",
        "DESCRIPTION": "",
        "CONFIRM": "Da, izbriši",
        "SUCCESS_MESSAGE": "Često pitanje uspješno izbrisano",
        "ERROR_MESSAGE": "Došlo je do greške pri brisanju čestog pitanja, pokušajte ponovno."
      },
      "FILTER": {
        "ASSISTANT": "Asistent: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Sve"
      },
      "STATUS": {
        "TITLE": "Status",
        "PENDING": "Na čekanju",
        "APPROVED": "Odobreno",
        "ALL": "Sve"
      },
      "FORM_DESCRIPTION": "Dodajte pitanje i pripadajući odgovor u bazu znanja i odaberite asistenta s kojim ga želite povezati.",
      "CREATE": {
        "TITLE": "Dodaj često pitanje",
        "SUCCESS_MESSAGE": "Odgovor je uspješno dodan.",
        "ERROR_MESSAGE": "Došlo je do greške pri dodavanju odgovora. Pokušajte ponovno."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Pitanje",
          "PLACEHOLDER": "Ovdje unesite pitanje",
          "ERROR": "Unesite valjano pitanje."
        },
        "ANSWER": {
          "LABEL": "Odgovor",
          "PLACEHOLDER": "Ovdje unesite odgovor",
          "ERROR": "Unesite valjani odgovor."
        },
        "ASSISTANT": {
          "LABEL": "Asistent",
          "PLACEHOLDER": "Odaberite asistenta",
          "ERROR": "Odaberite asistenta."
        }
      },
      "EDIT": {
        "TITLE": "Ažuriraj često pitanje",
        "SUCCESS_MESSAGE": "Često pitanje je uspješno ažurirano",
        "ERROR_MESSAGE": "Došlo je do greške pri ažuriranju čestog pitanja, pokušajte ponovno",
        "APPROVE_SUCCESS_MESSAGE": "Često pitanje je označeno kao odobreno"
      },
      "OPTIONS": {
        "APPROVE": "Označi kao odobreno",
        "EDIT_RESPONSE": "Uredi često pitanje",
        "DELETE_RESPONSE": "Izbriši često pitanje"
      },
      "EMPTY_STATE": {
        "TITLE": "Nema pronađenih čestih pitanja",
        "SUBTITLE": "Česta pitanja pomažu asistentu da brzo i točno odgovara na pitanja vaših klijenata. Mogu se generirati automatski iz vašeg sadržaja ili dodati ručno.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain česta pitanja",
          "NOTE": "Captain česta pitanja prepoznaju uobičajena pitanja klijenata – bilo da nedostaju u vašoj bazi znanja ili se često postavljaju – i generiraju relevantna česta pitanja za bolju podršku. Svaki prijedlog možete pregledati i odlučiti hoćete li ga odobriti ili odbiti."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Povezani sandučići",
      "ADD_NEW": "Poveži novi sandučić",
      "OPTIONS": {
        "DISCONNECT": "Prekini vezu"
      },
      "DELETE": {
        "TITLE": "Jeste li sigurni da želite odspojiti sandučić?",
        "DESCRIPTION": "",
        "CONFIRM": "Da, izbriši",
        "SUCCESS_MESSAGE": "Sandučić je uspješno odspojen.",
        "ERROR_MESSAGE": "Došlo je do greške pri odspajanju sandučića, pokušajte ponovno."
      },
      "FORM_DESCRIPTION": "Odaberite sandučić koji želite povezati s asistentom.",
      "CREATE": {
        "TITLE": "Poveži sandučić",
        "SUCCESS_MESSAGE": "Sandučić je uspješno povezan.",
        "ERROR_MESSAGE": "Došlo je do greške pri povezivanju sandučića. Pokušajte ponovno."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Sandučić",
          "PLACEHOLDER": "Odaberite sandučić u kojem će asistent raditi.",
          "ERROR": "Odabir sandučića je obavezan."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Nema povezanih sandučića",
        "SUBTITLE": "Povezivanjem sandučića asistent može obraditi početna pitanja vaših klijenata prije nego što ih preda vama."
      }
    }
  }
}
